import React from "react";


interface Props {
    description?: string;
    title?: string;
    action?: string;
}

export default function MessageScreen(props: Props) {
    const title = props.action ? props.action : props.title;
    const description = props.action ? `${props.action}_description` : props.description;

    return (
        <div className={"min-h-screen bg-gray-25 pt-5 text-center"}>
            <h1 className={"mb-2 text-3xl font-bold text-gray-700"}>
                {title}
            </h1>
            <p className={"text-lg text-gray-600"}>
                {description}
            </p>
        </div>
    );
}
